import { Logger } from "webpack/lib/logging/Logger";

const addComplaintCases = () => {
    const caseTypeSelect = document.getElementById('complaint_case_category');
    const caseDiv = document.querySelector('.related-case-div');
    const civilDiv = document.querySelector('.civil-case-div');
    const criminalDiv = document.querySelector('.criminal-case-div');

    const caseTypeDisplay = caseType => {
      caseType = caseType.trim().toLowerCase()
      if (caseType === 'civil') {
        // console.log("Civil case type selected.");
        civilDiv.style.display = 'block';
        criminalDiv.style.display = 'none';
      } else if (caseType === 'criminal') {
        // console.log("Criminal case type selected.");
        criminalDiv.style.display = 'block';
        civilDiv.style.display = 'none';
      } else {
        return;
      }
    };

    caseTypeSelect.addEventListener('change', e => {
      const selectedOption = e.target.value;

      // console.log("Case type selection made: " + selectedOption);

      if (selectedOption !== (undefined || '')) {
        caseDiv.style.display = 'block';
        caseTypeDisplay(selectedOption);
      } else {
        caseDiv.style.display = 'none';
      }
    });

}

document.addEventListener("DOMContentLoaded", function() {
  // Switch the display e-mail based on the latest selection
  $(document).on('click', 'input[name="complaint[formality_type]"]', function() {      
    
    const displayEmail = document.getElementById('displayed_contact_email');

    // displayEmail = document.getElementById('displayed_contact_email');
    // console.log("Formality type change to " + $(this).val());
    if($(this).val() == 'Formal Complaint') {
      // console.log("Formal complaint type selected");
      // console.log("formal email is " + displayEmail.dataset.formal);
      displayEmail.textContent = displayEmail.dataset.formal;
    } else {
      // console.log("Informal complaint type selected");
      displayEmail.textContent = displayEmail.dataset.informal;
    }
  });

  try {
    let case_type_dropdown = document.getElementById('complaint_case_category');
    if (case_type_dropdown != null && case_type_dropdown.length > 0) {
      // console.log("Adding case category drop down logic...");
      addComplaintCases();    
      
      var event = new Event('change');
      case_type_dropdown.dispatchEvent(event);

    }  

  } catch (error) {
    console.log("Case category drop down not on this page.");
    console.log(error);
  }

});
